import React, { FormEvent, forwardRef, useEffect } from 'react';
import styled from 'styled-components';

import { IFormValues } from '../../../types/shared';

import Checkbox from '../../atoms/checkbox/Checkbox';

import { DEQ_PAGE_TYPES, formTrackPageView } from '../../../utils/deq';

import mq from '../../../styles/breakpoints';

import ErrorMessage from '../../molecules/error-message/ErrorMessage';

import { FormProps } from './Form.types';

const validationConsent = {
  name: 'validation-consent',
  label: 'Validation Consent',
};

const Form = forwardRef(
  (
    {
      id,
      submit,
      children,
      hasError,
      stepName = '',
      deqFormName = '',
      deqFormType = 'lead-soft',
      trackPageView = true,
      trackFormStep = false,
      className,
      pageType = DEQ_PAGE_TYPES.contact,
    }: FormProps,
    ref
  ) => {
    useEffect(() => {
      if (trackPageView) {
        formTrackPageView(
          pageType,
          id,
          deqFormName,
          `${stepName}`.toLowerCase(),
          '10',
          'v1',
          deqFormType
        );
      } else if (trackFormStep) {
        formTrackPageView(
          '',
          id,
          deqFormName.toLowerCase(),
          stepName.toLowerCase(),
          '10',
          'v1',
          deqFormType,
          undefined,
          'form step'
        );
      }
    }, []);

    const onHandleSubmit = (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      event.stopPropagation();
      const result: IFormValues = {};

      for (let i = 0; i < event.target.length; i += 1) {
        const { name, value, type, checked, dataset } = event.target.elements[
          i
        ] as HTMLInputElement;

        if (name === validationConsent.name && checked) {
          // Prevent submit when spam bot has checked hidden checkbox.
          return;
        }

        if (name) {
          if (type === 'radio') {
            if (checked) {
              result[name] = value;
            }
          } else if (type === 'checkbox') {
            if (dataset) {
              if (dataset.optiontype === 'grouped-option') {
                if (checked) {
                  result[name] = value;
                }
              } else {
                result[name] = checked;
              }
            } else {
              result[name] = checked;
            }
          } else {
            result[name] = value;
          }
        }
      }

      submit(result);
    };

    return (
      <form
        data-testid="form"
        data-pw-testid="form"
        id={id}
        onSubmit={(event) => onHandleSubmit(event)}
        className={className}
        ref={ref}
      >
        <ValidationCheckbox
          key={validationConsent.name}
          id={validationConsent.name}
          testId={`${validationConsent.name}-checkbox`}
          name={validationConsent.name}
          label={validationConsent.label}
          tabIndex={-1}
        />
        <InputContainer>{children}</InputContainer>
        {hasError && <ErrorMessage>Download is niet gelukt</ErrorMessage>}
      </form>
    );
  }
);

export default Form;

const InputContainer = styled.div`
  width: 100%;

  ${mq.from.breakpoint.M`
  > * input {
    max-width: 400px;
  }
  > .checkbox {
    max-width: 100%;
  }
  `}
`;

const ValidationCheckbox = styled(Checkbox)`
  height: 0px;
  overflow: hidden;
`;
